import DailyCharacter from '@assets/icons/daily-character.svg'
import { Icon } from './Icon'

export const DailyCharacterIcon = Icon(DailyCharacter)
